import { ChangeEvent, useCallback } from 'react'
import _ from 'lodash'
import { submitStatusUpdates } from '../../../redux/submitStatusUpdates'
import L1ErrorBlock from '../l1/L1ErrorBlock'
import L3TextField from '../l3/L3TextField'
import { useFormDispatch } from '../../../redux/formStoreHooks'
import { ConceptStatusValueType, ConceptValueDataType } from '@fusion-advantage/backcompat'
import { isConceptStatus } from '@fusion-advantage/formlib'
import { useConceptStatus, useConceptStatusValidity } from '../../../redux/selectConceptStatus2'
import { useConceptValidator } from './useConceptValidator'
import { useConceptActivation } from '../../../redux/selectConcept'

interface L4TextFieldProps {
	xpath: string
	cid?: string,
	units?: string|null,
}

const L4TextField = ({xpath, cid, units}: L4TextFieldProps) => {
	const { concept, errorNode } = useConceptValidator({
		tagName: 'L4TextField',
		cid,
		requireConcept: true,
		allowDataTypes: [
			ConceptValueDataType.Date,
			ConceptValueDataType.Decimal,
			ConceptValueDataType.Integer,
			ConceptValueDataType.String,
		],
	})
	const conceptStatus = useConceptStatus(cid)
	const validity = useConceptStatusValidity(cid)
	const activation = useConceptActivation(cid)
	const dispatch = useFormDispatch()
	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		dispatch(submitStatusUpdates([{
			cid: cid!,
			value: e.target.value,
			valueType: ConceptStatusValueType.Chosen,
		}]))
	}, [dispatch, cid])
	if(errorNode) {
		return errorNode
	}
	if(conceptStatus && !isConceptStatus(conceptStatus)) {
		// probably passed SuperconceptStatus instead of ConceptStatus
		// which doesn't make sense for this control
		return <L1ErrorBlock content={`[L4TextField ${cid}] conceptStatus is incorrect type`} />
	}
	return (
		<L3TextField
			xpath={xpath}
			concept={concept!}
			conceptStatus={conceptStatus}
			validity={validity}
			activation={activation}
			onChange={handleChange}
			units={units}
		/>
	)
}

export default L4TextField
